import React from 'react';

export const ContentContext = React.createContext<Record<string, unknown>>({});

export default function useContentContext<T = Record<string, unknown>>() {
  const context = React.useContext(ContentContext);
  return context as T;
}
